module.exports = __webpack_public_path__ + "media/src/images/dandori/step7-0156fcc4177a63dcb36fe655c3d939b3.png";